import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forEach, map } from '@beef/utils';

/**
 * Fill parentId field for each node with parametrized value taken from entire tree children field
 */
export var fillCoreParentIds = function fillCoreParentIds(coreDSL) {
  var parentIds = {};
  /** iterate each node as parent */
  forEach(coreDSL, function (node, parentId) {
    /** iterate each parent children field */
    forEach(node.children || {}, function (prop) {
      /** iterate each parametrized children prop */
      prop.forEach(function (_ref) {
        var _ref$value = _ref.value,
          childIds = _ref$value === void 0 ? [] : _ref$value,
          params = _objectWithoutProperties(_ref, _excluded);
        /** finally iterate childIds */
        childIds.forEach(function (childId) {
          parentIds[childId] = [].concat(_toConsumableArray(parentIds[childId] || []), [_objectSpread(_objectSpread({}, params), {}, {
            value: parentId
          })]);
        });
      });
    });
  });
  return map(coreDSL, function (node, nodeId) {
    return _objectSpread(_objectSpread({}, node), {}, {
      parentId: parentIds[nodeId]
    });
  });
};